// Layout principal que envuelve las páginas autenticadas
import { Outlet } from 'react-router-dom'
import Navbar from './Navbar'
import Sidebar from './Sidebar'
import Footer from './Footer'
import BottomNavigation from './BottomNavigation'

export default function Layout({ showSidebar = true, showFooter = true }) {
  return (
    <div className="min-h-screen flex flex-col bg-surface-dark">
      {/* Barra de navegación fija superior */}
      <Navbar />

      {/* Área de contenido principal */}
      <div className="flex flex-1 pt-16">
        {/* Sidebar lateral (solo en pantallas grandes) */}
        {showSidebar && <Sidebar />}

        {/* Contenido de la página actual */}
        <main className="flex-1 min-w-0 pb-16 lg:pb-0">
          <Outlet />
        </main>
      </div>

      {/* Barra de navegación inferior móvil */}
      <BottomNavigation />

      {/* Pie de página */}
      {showFooter && (
        <div className="pb-16 lg:pb-0">
          <Footer />
        </div>
      )}
    </div>
  )
}
